import { Card, CardBody, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import ProfileDetailsForm from "./components/form/ProfileDetailsForm";
import ResetPasswordForm from "./components/form/ResetPasswordForm";

const AccountPage = () => {

    return (
        <div className="my-5">
            <Card className="shadow-sm py-4">
                <CardHeader className="">
                    <CardTitle>Account</CardTitle>
                    <CardDescription>Manage your personal information and security settings
                    </CardDescription>
                </CardHeader>

                <CardBody>
                    <ProfileDetailsForm />

                    {/* Separator */}
                    <div className="separator separator-dashed my-10"></div>

                    <ResetPasswordForm />
                </CardBody>
            </Card>
        </div>

    );
};

export default AccountPage;